import { DocumentTitleOptions } from "@react-navigation/native";

export const documentTitleFormatter: NonNullable<
  DocumentTitleOptions["formatter"]
> = ({ title } = {}) =>
  [title, "Ticket Scanner | The Good Ticket Company"].join(" | ");
